const PHONE_NUMBER = '77089071712';

export const sendToWhatsApp = (message: string, source?: string) => {
  const utm = source ? `\n\n📌 Источник: сайт kazpolimerplast.kz — ${source}` : '\n\n📌 Источник: сайт kazpolimerplast.kz';
  window.open(
    `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(message + utm)}`,
    '_blank'
  );
};
